export default __webpack_public_path__ + "static/media/refer-graphic.05322034.png";